import { AsyncPipe } from '@angular/common'
import { Inject, Pipe, PipeTransform } from '@angular/core'
import { SharedAuctionFacade } from 'libs/shared/models/auction/auction.models'
import { map } from 'rxjs'

@Pipe({
  name: 'gbEventTicketSeatLabel',
})
export class GbEventTicketSeatLabelPipe implements PipeTransform {
  constructor(private asyncPipe: AsyncPipe, @Inject('AuctionFacade') private auctionFacade: SharedAuctionFacade) {}

  transform(seatNumber: number): string | null {
    return this.asyncPipe.transform(
      this.auctionFacade.ticketsLabel$.pipe(map((ticketsLabel) => `${ticketsLabel.slice(0, -1)} ${seatNumber}`)),
    )
  }
}
